import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const flag = route.data['featureFlag'] as keyof typeof environment.featureFlags;

        if (environment.featureFlags[flag]) {
            return true;
        }

        return this.router.parseUrl('/home');
    }
}
